module.exports = __webpack_public_path__ + "static/img/pexels-photo-938639.7e51d34.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels-photo-938639.webp
// module id = 4IvV
// module chunks = 0